import React from "react";
import { HiX } from "react-icons/hi";

import type { TDockTone } from "./styledComponents";
import {
  ActionButton,
  CardMeta,
  CardRow,
  CardTitle,
  DockCloseButton,
  DockSurface,
  IconSlot,
  MetaRow,
} from "./styledComponents";

export type TDockCardProps = {
  icon: React.ReactNode;
  title: string;
  meta?: string;
  tone?: TDockTone;
  actionLabel: string;
  onAction: () => void;
  onDismiss: () => void;
};

export const DockCard = ({
  icon,
  title,
  meta,
  tone = "neutral",
  actionLabel,
  onAction,
  onDismiss,
}: TDockCardProps) => (
  <DockSurface
    aria-label={title}
    onKeyDown={(e: React.KeyboardEvent) => {
      if (e.key === "Escape") onDismiss();
    }}
    role="group"
  >
    <CardRow>
      <IconSlot $tone={tone}>{icon}</IconSlot>
      <CardTitle>{title}</CardTitle>
      <DockCloseButton
        aria-label={`Dismiss: ${title}`}
        onClick={onDismiss}
        type="button"
      >
        <HiX size={16} />
      </DockCloseButton>
    </CardRow>
    <MetaRow>
      <CardMeta>{meta}</CardMeta>
      <ActionButton onClick={onAction} type="button">
        {actionLabel}
      </ActionButton>
    </MetaRow>
  </DockSurface>
);
